let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1A7FL")).then(() => parcelRequire('daaVW'));